import React, { Component } from "react";

import {
  CCard,
  CCardBody,
  CCardFooter,
  CImg,
  CLink,
  CCollapse,
  CRow,
  CCol,
  CButton,
  CBadge,
  CSelect,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Loading from "../Loading";
import Statistics from "../Statistics/StatisticsActivityDo/statisticsActivityDo";

class CommunityContentActivities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      todayCollapse: false,
      todayLoading: false,
      todayContent: null,
      weekCollapse: false,
      weekLoading: false,
      weekContent: null,
      nextCollapse: false,
      nextLoading: false,
      nextContent: null,
      prevCollapse: false,
      prevLoading: false,
      prevContent: null,
      statisticsModal: null,
      users: [],
      disciplines: [],
      loading: true,
      user: 0,
      discipline: 0
    };
  }

  componentDidMount() {
    this.loadFilters();
    this.toggleToday();
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  friendlyDate(date) {
    const dt = new Date(date);
    const hj = new Date();
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ];

    if (dt.getFullYear() !== hj.getFullYear()) {
      return `${dt.getDate()} de ${
        months[dt.getMonth()]
      } de ${dt.getFullYear()}`;
    }

    return `${dt.getDate()} de ${
      months[dt.getMonth()]
    }, às ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(
      -2
    )}`;
  }

  getActivities(from, to, prefix) {
    const { id } = this.props.match.params;

    axios
      .post(
        `${URL.api}activity/activity/filter`,
        {
          user: this.props.user.user.id,
          room: id,
          from,
          to,
          types: [1, 2, 4]
        },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          switch (prefix) {
            case "prev":
              this.setState({
                prevContent: resp.data.data,
                prevLoading: false
              });
              break;
            case "next":
              this.setState({
                nextContent: resp.data.data,
                nextLoading: false
              });
              break;
            case "week":
              this.setState({
                weekContent: resp.data.data,
                weekLoading: false
              });
              break;
            case "today":
              this.setState({
                todayContent: resp.data.data,
                todayLoading: false
              });
              break;
            default:
              break;
          }
        },
        error => {
          this.error("Não foi possível buscar as atividades");
        }
      );
  }

  toggleToday() {
    this.setState(
      state => ({ todayCollapse: !state.todayCollapse }),
      () => {
        if (this.state.todayCollapse) {
          this.setState({ todayLoading: true });

          const today = new Date();
          const day = `00${today.getDate()}`.slice(-2);
          const month = `00${today.getMonth() + 1}`.slice(-2);
          const year = today.getFullYear();

          this.getActivities(
            `${year}-${month}-${day} 00:00:00`,
            `${year}-${month}-${day} 23:59:59`,
            "today"
          );
        }
      }
    );
  }

  toggleWeek() {
    this.setState(
      state => ({ weekCollapse: !state.weekCollapse }),
      () => {
        if (this.state.weekCollapse) {
          this.setState({ weekLoading: true });

          const today = new Date();
          const day = today.getDay();

          const first = new Date(today.valueOf() - day * 86400000);
          const last = new Date(first.valueOf() + 6 * 86400000);

          const firstDay = `00${first.getDate()}`.slice(-2);
          const firstMonth = `00${first.getMonth() + 1}`.slice(-2);
          const firstYear = first.getFullYear();

          const lastDay = `00${last.getDate()}`.slice(-2);
          const lastMonth = `00${last.getMonth() + 1}`.slice(-2);
          const lastYear = last.getFullYear();

          this.getActivities(
            `${firstYear}-${firstMonth}-${firstDay} 00:00:00`,
            `${lastYear}-${lastMonth}-${lastDay} 23:59:59`,
            "week"
          );
        }
      }
    );
  }

  toggleNext() {
    this.setState(
      state => ({ nextCollapse: !state.nextCollapse }),
      () => {
        if (this.state.nextCollapse) {
          this.setState({ nextLoading: true });

          const today = new Date();
          const day = `00${today.getDate()}`.slice(-2);
          const month = `00${today.getMonth() + 1}`.slice(-2);
          const year = today.getFullYear();
          const hour = `00${today.getHours()}`.slice(-2);
          const minutes = `00${today.getMinutes()}`.slice(-2);
          const seconds = `00${today.getSeconds()}`.slice(-2);

          this.getActivities(
            `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`,
            `${year}-12-31 23:59:59`,
            "next"
          );
        }
      }
    );
  }

  togglePrev() {
    this.setState(
      state => ({ prevCollapse: !state.prevCollapse }),
      () => {
        if (this.state.prevCollapse) {
          this.setState({ prevLoading: true });

          const today = new Date();
          const day = `00${today.getDate()}`.slice(-2);
          const month = `00${today.getMonth() + 1}`.slice(-2);
          const year = today.getFullYear();
          const hour = `00${today.getHours()}`.slice(-2);
          const minutes = `00${today.getMinutes()}`.slice(-2);
          const seconds = `00${today.getSeconds()}`.slice(-2);

          this.getActivities(
            `${year}-01-01 00:00:00`,
            `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`,
            "prev"
          );
        }
      }
    );
  }

  showGrade(activity) {
    const ended = new Date(activity.activity_end) < new Date();

    if (["SEMPRE", "NOTA"].includes(activity.result_type)) {
      return true;
    }

    if (activity.result_type === "TERMINO" && ended) {
      return true;
    }

    return false;
  }

  loadFilters() {
    const { id } = this.props.match.params;
    axios
      .get(`${URL.api}community/room/singleView/${id}`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            users: resp.data.data.room_user,
            disciplines: resp.data.data.room_discipline,
            loading: false
          });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    let isTeacherAlagoas =
      this.props.user.user_roles[0].role_id === 6 &&
      this.props.user.user_roles[0].group_id === 86;
    return (
      <>
        {this.state.statisticsModal && (
          <Statistics
            show={this.state.statisticsModal !== null}
            onClose={() => this.setState({ statisticsModal: null })}
            allocation_id={this.state.statisticsModal}
            currentRoute={this.props.currentRoute}
          />
        )}
        <div className="d-flex justify-content-between mb-3">
          <div className="d-flex align-items-center">
            <CInputGroup className="mr-3">
              <CInputGroupPrepend>
                <CInputGroupText>
                  <i className="fa fa-user"></i>
                </CInputGroupText>
              </CInputGroupPrepend>
              <CSelect
                value={this.state.user}
                onChange={e =>
                  this.setState({ user: parseInt(e.target.value) })
                }
              >
                {this.state.loading ? (
                  <option value="0">Carregando...</option>
                ) : (
                  <>
                    <option value="0">Todos</option>
                    {this.state.users
                      .filter(user => user.administrator)
                      .map(user => (
                        <option key={user.user_id} value={user.user_id}>
                          {user.user_name}
                        </option>
                      ))}
                  </>
                )}
              </CSelect>
            </CInputGroup>
            {!this.props.isRoom && (
              <CInputGroup className="mr-3">
                <CInputGroupPrepend>
                  <CInputGroupText>
                    <i className="fa fa-book"></i>
                  </CInputGroupText>
                </CInputGroupPrepend>
                <CSelect
                  value={this.state.discipline}
                  onChange={e =>
                    this.setState({ discipline: parseInt(e.target.value) })
                  }
                >
                  {this.state.loading ? (
                    <option value="0">Carregando...</option>
                  ) : (
                    <>
                      <option value="0">Todas</option>
                      {this.state.disciplines.map(discipline => (
                        <option
                          key={discipline.discipline_id}
                          value={discipline.discipline_id}
                        >
                          {discipline.discipline_name}
                        </option>
                      ))}
                    </>
                  )}
                </CSelect>
              </CInputGroup>
            )}
          </div>
          {this.props.hasPrivilege && !isTeacherAlagoas && (
            <CButton color="primary" to="/activity/create">
              <i className="fa fa-plus mr-2"></i>Nova
            </CButton>
          )}
        </div>
        <div className="d-flex align-items-center justify-content-between">
          <h4 className="m-0">Hoje</h4>
          <i
            onClick={() => this.toggleToday()}
            className={`text-muted activity-collapse fa fa-chevron-${
              this.state.todayCollapse ? "up" : "down"
            }`}
          ></i>
        </div>
        <hr style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }} />
        <CCollapse show={this.state.todayCollapse}>
          {this.state.todayLoading ? (
            <div className="p-3">
              <Loading />
            </div>
          ) : (
            <React.Fragment>
              {this.state.todayContent &&
              this.state.todayContent.filter(
                activity =>
                  activity.name
                    .toLowerCase()
                    .includes(this.props.search.toLowerCase()) &&
                  (!this.state.discipline ||
                    activity.discipline_id === this.state.discipline) &&
                  (!this.state.user || activity.user_id === this.state.user)
              ).length > 0 ? (
                <CRow>
                  {this.state.todayContent
                    .filter(
                      activity =>
                        activity.name
                          .toLowerCase()
                          .includes(this.props.search.toLowerCase()) &&
                        (!this.state.discipline ||
                          activity.discipline_id === this.state.discipline) &&
                        (!this.state.user ||
                          activity.user_id === this.state.user)
                    )
                    .map((activity, index) => (
                      <CCol key={index} sm="12" lg="6">
                        <CLink
                          className="not-link"
                          to={`/activity/${
                            activity.type_id === 2 ? "live" : "do"
                          }/${activity.allocation_id}`}
                          target={activity.type_id === 2 ? "_blank" : null}
                        >
                          <CCard className="card-room-activity">
                            <CCardBody className="d-flex align-items-center">
                              <div
                                style={{
                                  height: "60px",
                                  width: "60px",
                                  position: "relative"
                                }}
                              >
                                <CImg
                                  src={
                                    activity.user_photo
                                      ? URL.img + activity.user_photo
                                      : `${URL.img}uploads/users/profileEmpty.jpg`
                                  }
                                  style={{
                                    height: "60px",
                                    width: "60px",
                                    borderRadius: "100%"
                                  }}
                                />
                                {activity.type_id !== 2 &&
                                activity.activity_percentage ? (
                                  <div
                                    className="bg-success d-flex justify-content-center align-items-center"
                                    style={{
                                      position: "absolute",
                                      bottom: "-1px",
                                      right: "-1px",
                                      width: "1.25rem",
                                      height: "1.25rem",
                                      borderRadius: "100%",
                                      fontSize: "0.75rem",
                                      border: "2px solid white"
                                    }}
                                  >
                                    <i className="fa fa-check text-white" />
                                  </div>
                                ) : activity.type_id !== 2 &&
                                  new Date(activity.activity_end) <
                                    new Date() ? (
                                  <div
                                    className="bg-danger d-flex justify-content-center align-items-center"
                                    style={{
                                      position: "absolute",
                                      bottom: "-1px",
                                      right: "-1px",
                                      width: "1.25rem",
                                      height: "1.25rem",
                                      borderRadius: "100%",
                                      fontSize: "0.75rem",
                                      border: "2px solid white"
                                    }}
                                  >
                                    <i className="fa fa-close text-white" />
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="d-flex flex-column justify-content-center ml-3 align-items-start flex-1">
                                <div className="w-100 d-flex justify-content-between align-items-center mb-1">
                                  <h5
                                    className="text-overflow m-0"
                                    style={{ wordBreak: "break-all" }}
                                  >
                                    {activity.name}
                                  </h5>
                                  {this.props.hasPrivilege &&
                                    activity.type_id !== 2 && (
                                      <i
                                        className="fa fa-pie-chart community-chart-icon cursor"
                                        onClick={e => {
                                          this.setState({
                                            statisticsModal:
                                              activity.allocation_id
                                          });
                                          e.preventDefault();
                                        }}
                                      ></i>
                                    )}
                                  {!this.props.hasPrivilege && (
                                    <div className="d-flex align-items-center">
                                      {this.showGrade(activity) &&
                                        activity.items.findIndex(
                                          item => item.item_grade !== null
                                        ) !== -1 && (
                                          <CBadge
                                            color="primary"
                                            className="mr-2 p-1"
                                          >
                                            <i className="fa fa-check-square-o mr-2"></i>
                                            {
                                              activity.items.find(
                                                item => item.item_grade !== null
                                              ).item_grade
                                            }
                                          </CBadge>
                                        )}
                                    </div>
                                  )}
                                </div>
                                <div className="d-flex align-items-center">
                                  {activity.user_name}
                                  {activity.homework && (
                                    <CBadge color="info" className="ml-2">
                                      Casa
                                    </CBadge>
                                  )}
                                </div>
                                {activity.type_id === 2 ? (
                                  new Date(activity.activity_end) <
                                  new Date() ? (
                                    <CBadge
                                      color="secondary"
                                      className="d-inline mt-1 p-1"
                                    >
                                      Encerrada
                                    </CBadge>
                                  ) : new Date(activity.activity_start) >
                                    new Date() ? (
                                    <CBadge
                                      color="light"
                                      className="d-inline mt-1 p-1"
                                    >
                                      Em breve
                                    </CBadge>
                                  ) : (
                                    <CBadge
                                      color="danger"
                                      className="d-inline mt-1 p-1"
                                    >
                                      Ao vivo
                                    </CBadge>
                                  )
                                ) : (
                                  <div className="text-muted small mt-1">
                                    {`${this.friendlyDate(
                                      activity.activity_start
                                    )} - ${this.friendlyDate(
                                      activity.activity_end
                                    )}`}
                                  </div>
                                )}
                              </div>
                            </CCardBody>
                            {activity.items.length !== 0 && (
                              <CCardFooter className="d-flex align-items-center justify-content-start overflow-hidden">
                                <div className="d-flex" style={{ flex: 1 }}>
                                  {activity.items.map(item => (
                                    <div
                                      key={item.id}
                                      className={`activity-item-icon activity-item-icon-${item.type_color}`}
                                    >
                                      <i
                                        className={`fa fa-${item.type_icon}`}
                                      ></i>
                                    </div>
                                  ))}
                                </div>
                              </CCardFooter>
                            )}
                          </CCard>
                        </CLink>
                      </CCol>
                    ))}
                </CRow>
              ) : (
                <div className="d-flex align-items-center justify-content-center p-3 text-muted">
                  Nenhuma atividade encontrada
                </div>
              )}
            </React.Fragment>
          )}
        </CCollapse>
        <div className="pt-3 d-flex align-items-center justify-content-between">
          <h4 className="m-0">Essa semana</h4>
          <i
            onClick={() => this.toggleWeek()}
            className={`text-muted activity-collapse fa fa-chevron-${
              this.state.weekCollapse ? "up" : "down"
            }`}
          ></i>
        </div>
        <hr style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }} />
        <CCollapse show={this.state.weekCollapse}>
          {this.state.weekLoading ? (
            <div className="p-3">
              <Loading />
            </div>
          ) : (
            <React.Fragment>
              {this.state.weekContent &&
              this.state.weekContent.filter(
                activity =>
                  activity.name
                    .toLowerCase()
                    .includes(this.props.search.toLowerCase()) &&
                  (!this.state.discipline ||
                    activity.discipline_id === this.state.discipline) &&
                  (!this.state.user || activity.user_id === this.state.user)
              ).length > 0 ? (
                <CRow>
                  {this.state.weekContent
                    .filter(
                      activity =>
                        activity.name
                          .toLowerCase()
                          .includes(this.props.search.toLowerCase()) &&
                        (!this.state.discipline ||
                          activity.discipline_id === this.state.discipline) &&
                        (!this.state.user ||
                          activity.user_id === this.state.user)
                    )
                    .map((activity, index) => (
                      <CCol key={index} sm="12" lg="6">
                        <CLink
                          className="not-link"
                          to={`/activity/${
                            activity.type_id === 2 ? "live" : "do"
                          }/${activity.allocation_id}`}
                          target={activity.type_id === 2 ? "_blank" : null}
                        >
                          <CCard className="card-room-activity">
                            <CCardBody
                              className="d-flex align-items-center"
                              style={{ wordBreak: "break-word" }}
                            >
                              <div
                                style={{
                                  height: "60px",
                                  width: "60px",
                                  position: "relative"
                                }}
                              >
                                <CImg
                                  src={
                                    activity.user_photo
                                      ? URL.img + activity.user_photo
                                      : `${URL.img}uploads/users/profileEmpty.jpg`
                                  }
                                  style={{
                                    height: "60px",
                                    width: "60px",
                                    borderRadius: "100%"
                                  }}
                                />
                                {activity.type_id !== 2 &&
                                activity.activity_percentage ? (
                                  <div
                                    className="bg-success d-flex justify-content-center align-items-center"
                                    style={{
                                      position: "absolute",
                                      bottom: "-1px",
                                      right: "-1px",
                                      width: "1.25rem",
                                      height: "1.25rem",
                                      borderRadius: "100%",
                                      fontSize: "0.75rem",
                                      border: "2px solid white"
                                    }}
                                  >
                                    <i className="fa fa-check text-white" />
                                  </div>
                                ) : activity.type_id !== 2 &&
                                  new Date(activity.activity_end) <
                                    new Date() ? (
                                  <div
                                    className="bg-danger d-flex justify-content-center align-items-center"
                                    style={{
                                      position: "absolute",
                                      bottom: "-1px",
                                      right: "-1px",
                                      width: "1.25rem",
                                      height: "1.25rem",
                                      borderRadius: "100%",
                                      fontSize: "0.75rem",
                                      border: "2px solid white"
                                    }}
                                  >
                                    <i className="fa fa-close text-white" />
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="d-flex flex-column justify-content-center ml-3 align-items-start flex-1">
                                <div className="w-100 d-flex justify-content-between align-items-center mb-1">
                                  <h5
                                    className="text-overflow m-0"
                                    style={{ wordBreak: "break-all" }}
                                  >
                                    {activity.name}
                                  </h5>
                                  {this.props.hasPrivilege && (
                                    <i
                                      className="fa fa-pie-chart community-chart-icon cursor"
                                      onClick={e => {
                                        this.setState({
                                          statisticsModal:
                                            activity.allocation_id
                                        });
                                        e.preventDefault();
                                      }}
                                    ></i>
                                  )}
                                  {!this.props.hasPrivilege && (
                                    <div className="d-flex align-items-center">
                                      {this.showGrade(activity) &&
                                        activity.items.findIndex(
                                          item => item.item_grade !== null
                                        ) !== -1 && (
                                          <CBadge
                                            color="primary"
                                            className="mr-2 p-1"
                                          >
                                            <i className="fa fa-check-square-o mr-2"></i>
                                            {
                                              activity.items.find(
                                                item => item.item_grade !== null
                                              ).item_grade
                                            }
                                          </CBadge>
                                        )}
                                    </div>
                                  )}
                                </div>
                                <div className="d-flex align-items-center">
                                  {activity.user_name}
                                  {activity.homework && (
                                    <CBadge color="info" className="ml-2">
                                      Casa
                                    </CBadge>
                                  )}
                                </div>
                                {activity.type_id === 2 ? (
                                  new Date(activity.activity_end) <
                                  new Date() ? (
                                    <CBadge
                                      color="secondary"
                                      className="d-inline mt-1 p-1"
                                    >
                                      Encerrada
                                    </CBadge>
                                  ) : new Date(activity.activity_start) >
                                    new Date() ? (
                                    <CBadge
                                      color="light"
                                      className="d-inline mt-1 p-1"
                                    >
                                      Em breve
                                    </CBadge>
                                  ) : (
                                    <CBadge
                                      color="danger"
                                      className="d-inline mt-1 p-1"
                                    >
                                      Ao vivo
                                    </CBadge>
                                  )
                                ) : (
                                  <div className="text-muted small mt-1">
                                    {`${this.friendlyDate(
                                      activity.activity_start
                                    )} - ${this.friendlyDate(
                                      activity.activity_end
                                    )}`}
                                  </div>
                                )}
                              </div>
                            </CCardBody>
                            {activity.items.length !== 0 && (
                              <CCardFooter className="d-flex align-items-center justify-content-start overflow-hidden">
                                <div className="d-flex" style={{ flex: 1 }}>
                                  {activity.items.map(item => (
                                    <div
                                      key={item.id}
                                      className={`activity-item-icon activity-item-icon-${item.type_color}`}
                                    >
                                      <i
                                        className={`fa fa-${item.type_icon}`}
                                      ></i>
                                    </div>
                                  ))}
                                </div>
                              </CCardFooter>
                            )}
                          </CCard>
                        </CLink>
                      </CCol>
                    ))}
                </CRow>
              ) : (
                <div className="d-flex align-items-center justify-content-center p-3 text-muted">
                  Nenhuma atividade encontrada
                </div>
              )}
            </React.Fragment>
          )}
        </CCollapse>
        <div className="pt-3 d-flex align-items-center justify-content-between">
          <h4 className="m-0">Próximas semanas</h4>
          <i
            onClick={() => this.toggleNext()}
            className={`text-muted activity-collapse fa fa-chevron-${
              this.state.nextCollapse ? "up" : "down"
            }`}
          ></i>
        </div>
        <hr style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }} />
        <CCollapse show={this.state.nextCollapse}>
          {this.state.nextLoading ? (
            <div className="p-3">
              <Loading />
            </div>
          ) : (
            <React.Fragment>
              {this.state.nextContent &&
              this.state.nextContent.filter(
                activity =>
                  activity.name
                    .toLowerCase()
                    .includes(this.props.search.toLowerCase()) &&
                  (!this.state.discipline ||
                    activity.discipline_id === this.state.discipline) &&
                  (!this.state.user || activity.user_id === this.state.user)
              ).length > 0 ? (
                <CRow>
                  {this.state.nextContent
                    .filter(
                      activity =>
                        activity.name
                          .toLowerCase()
                          .includes(this.props.search.toLowerCase()) &&
                        (!this.state.discipline ||
                          activity.discipline_id === this.state.discipline) &&
                        (!this.state.user ||
                          activity.user_id === this.state.user)
                    )
                    .map((activity, index) => (
                      <CCol key={index} sm="12" lg="6">
                        <CLink
                          className="not-link"
                          to={`/activity/${
                            activity.type_id === 2 ? "live" : "do"
                          }/${activity.allocation_id}`}
                          target={activity.type_id === 2 ? "_blank" : null}
                        >
                          <CCard className="card-room-activity">
                            <CCardBody className="d-flex align-items-center">
                              <div
                                style={{
                                  height: "60px",
                                  width: "60px",
                                  position: "relative"
                                }}
                              >
                                <CImg
                                  src={
                                    activity.user_photo
                                      ? URL.img + activity.user_photo
                                      : `${URL.img}uploads/users/profileEmpty.jpg`
                                  }
                                  style={{
                                    height: "60px",
                                    width: "60px",
                                    borderRadius: "100%"
                                  }}
                                />
                                {activity.type_id !== 2 &&
                                activity.activity_percentage ? (
                                  <div
                                    className="bg-success d-flex justify-content-center align-items-center"
                                    style={{
                                      position: "absolute",
                                      bottom: "-1px",
                                      right: "-1px",
                                      width: "1.25rem",
                                      height: "1.25rem",
                                      borderRadius: "100%",
                                      fontSize: "0.75rem",
                                      border: "2px solid white"
                                    }}
                                  >
                                    <i className="fa fa-check text-white" />
                                  </div>
                                ) : activity.type_id !== 2 &&
                                  new Date(activity.activity_end) <
                                    new Date() ? (
                                  <div
                                    className="bg-danger d-flex justify-content-center align-items-center"
                                    style={{
                                      position: "absolute",
                                      bottom: "-1px",
                                      right: "-1px",
                                      width: "1.25rem",
                                      height: "1.25rem",
                                      borderRadius: "100%",
                                      fontSize: "0.75rem",
                                      border: "2px solid white"
                                    }}
                                  >
                                    <i className="fa fa-close text-white" />
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="d-flex flex-column justify-content-center ml-3 align-items-start flex-1">
                                <div className="w-100 d-flex justify-content-between align-items-center mb-1">
                                  <h5
                                    className="text-overflow m-0"
                                    style={{ wordBreak: "break-all" }}
                                  >
                                    {activity.name}
                                  </h5>
                                  {this.props.hasPrivilege && (
                                    <i
                                      className="fa fa-pie-chart community-chart-icon cursor"
                                      onClick={e => {
                                        this.setState({
                                          statisticsModal:
                                            activity.allocation_id
                                        });
                                        e.preventDefault();
                                      }}
                                    ></i>
                                  )}
                                  {!this.props.hasPrivilege && (
                                    <div className="d-flex align-items-center">
                                      {this.showGrade(activity) &&
                                        activity.items.findIndex(
                                          item => item.item_grade !== null
                                        ) !== -1 && (
                                          <CBadge
                                            color="primary"
                                            className="mr-2 p-1"
                                          >
                                            <i className="fa fa-check-square-o mr-2"></i>
                                            {
                                              activity.items.find(
                                                item => item.item_grade !== null
                                              ).item_grade
                                            }
                                          </CBadge>
                                        )}
                                    </div>
                                  )}
                                </div>
                                <div className="d-flex align-items-center">
                                  {activity.user_name}
                                  {activity.homework && (
                                    <CBadge color="info" className="ml-2">
                                      Casa
                                    </CBadge>
                                  )}
                                </div>
                                {activity.type_id === 2 ? (
                                  new Date(activity.activity_end) <
                                  new Date() ? (
                                    <CBadge
                                      color="secondary"
                                      className="d-inline mt-1 p-1"
                                    >
                                      Encerrada
                                    </CBadge>
                                  ) : new Date(activity.activity_start) >
                                    new Date() ? (
                                    <CBadge
                                      color="light"
                                      className="d-inline mt-1 p-1"
                                    >
                                      Em breve
                                    </CBadge>
                                  ) : (
                                    <CBadge
                                      color="danger"
                                      className="d-inline mt-1 p-1"
                                    >
                                      Ao vivo
                                    </CBadge>
                                  )
                                ) : (
                                  <div className="text-muted small mt-1">
                                    {`${this.friendlyDate(
                                      activity.activity_start
                                    )} - ${this.friendlyDate(
                                      activity.activity_end
                                    )}`}
                                  </div>
                                )}
                              </div>
                            </CCardBody>
                            {activity.items.length !== 0 && (
                              <CCardFooter className="d-flex align-items-center justify-content-start overflow-hidden">
                                <div className="d-flex" style={{ flex: 1 }}>
                                  {activity.items.map(item => (
                                    <div
                                      key={item.id}
                                      className={`activity-item-icon activity-item-icon-${item.type_color}`}
                                    >
                                      <i
                                        className={`fa fa-${item.type_icon}`}
                                      ></i>
                                    </div>
                                  ))}
                                </div>
                              </CCardFooter>
                            )}
                          </CCard>
                        </CLink>
                      </CCol>
                    ))}
                </CRow>
              ) : (
                <div className="d-flex align-items-center justify-content-center p-3 text-muted">
                  Nenhuma atividade encontrada
                </div>
              )}
            </React.Fragment>
          )}
        </CCollapse>
        <div className="pt-3 d-flex align-items-center justify-content-between">
          <h4 className="m-0">Semanas anteriores</h4>
          <i
            onClick={() => this.togglePrev()}
            className={`text-muted activity-collapse fa fa-chevron-${
              this.state.prevCollapse ? "up" : "down"
            }`}
          ></i>
        </div>
        <hr style={{ marginTop: "0.75rem", marginBottom: "1.5rem" }} />
        <CCollapse show={this.state.prevCollapse}>
          {this.state.prevLoading ? (
            <div className="p-3">
              <Loading />
            </div>
          ) : (
            <React.Fragment>
              {this.state.prevContent &&
              this.state.prevContent.filter(
                activity =>
                  activity.name
                    .toLowerCase()
                    .includes(this.props.search.toLowerCase()) &&
                  (!this.state.discipline ||
                    activity.discipline_id === this.state.discipline) &&
                  (!this.state.user || activity.user_id === this.state.user)
              ).length > 0 ? (
                <CRow>
                  {this.state.prevContent
                    .filter(
                      activity =>
                        activity.name
                          .toLowerCase()
                          .includes(this.props.search.toLowerCase()) &&
                        (!this.state.discipline ||
                          activity.discipline_id === this.state.discipline) &&
                        (!this.state.user ||
                          activity.user_id === this.state.user)
                    )
                    .map((activity, index) => (
                      <CCol key={index} sm="12" lg="6">
                        <CLink
                          className="not-link"
                          to={`/activity/${
                            activity.type_id === 2 ? "live" : "do"
                          }/${activity.allocation_id}`}
                          target={activity.type_id === 2 ? "_blank" : null}
                        >
                          <CCard className="card-room-activity">
                            <CCardBody className="d-flex align-items-center">
                              <div
                                style={{
                                  height: "60px",
                                  width: "60px",
                                  position: "relative"
                                }}
                              >
                                <CImg
                                  src={
                                    activity.user_photo
                                      ? URL.img + activity.user_photo
                                      : `${URL.img}uploads/users/profileEmpty.jpg`
                                  }
                                  style={{
                                    height: "60px",
                                    width: "60px",
                                    borderRadius: "100%"
                                  }}
                                />
                                {activity.type_id !== 2 &&
                                activity.activity_percentage ? (
                                  <div
                                    className="bg-success d-flex justify-content-center align-items-center"
                                    style={{
                                      position: "absolute",
                                      bottom: "-1px",
                                      right: "-1px",
                                      width: "1.25rem",
                                      height: "1.25rem",
                                      borderRadius: "100%",
                                      fontSize: "0.75rem",
                                      border: "2px solid white"
                                    }}
                                  >
                                    <i className="fa fa-check text-white" />
                                  </div>
                                ) : activity.type_id !== 2 &&
                                  new Date(activity.activity_end) <
                                    new Date() ? (
                                  <div
                                    className="bg-danger d-flex justify-content-center align-items-center"
                                    style={{
                                      position: "absolute",
                                      bottom: "-1px",
                                      right: "-1px",
                                      width: "1.25rem",
                                      height: "1.25rem",
                                      borderRadius: "100%",
                                      fontSize: "0.75rem",
                                      border: "2px solid white"
                                    }}
                                  >
                                    <i className="fa fa-close text-white" />
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="d-flex flex-column justify-content-center ml-3 align-items-start flex-1">
                                <div className="w-100 d-flex justify-content-between align-items-center mb-1">
                                  <h5
                                    className="text-overflow m-0"
                                    style={{ wordBreak: "break-all" }}
                                  >
                                    {activity.name}
                                  </h5>
                                  {this.props.hasPrivilege && (
                                    <i
                                      className="fa fa-pie-chart community-chart-icon cursor"
                                      onClick={e => {
                                        this.setState({
                                          statisticsModal:
                                            activity.allocation_id
                                        });
                                        e.preventDefault();
                                      }}
                                    ></i>
                                  )}
                                  {!this.props.hasPrivilege && (
                                    <div className="d-flex align-items-center">
                                      {this.showGrade(activity) &&
                                        activity.items.findIndex(
                                          item => item.item_grade !== null
                                        ) !== -1 && (
                                          <CBadge
                                            color="primary"
                                            className="mr-2 p-1"
                                          >
                                            <i className="fa fa-check-square-o mr-2"></i>
                                            {
                                              activity.items.find(
                                                item => item.item_grade !== null
                                              ).item_grade
                                            }
                                          </CBadge>
                                        )}
                                    </div>
                                  )}
                                </div>
                                <div className="d-flex align-items-center">
                                  {activity.user_name}
                                  {activity.homework && (
                                    <CBadge color="info" className="ml-2">
                                      Casa
                                    </CBadge>
                                  )}
                                </div>
                                {activity.type_id === 2 ? (
                                  new Date(activity.activity_end) <
                                  new Date() ? (
                                    <CBadge
                                      color="secondary"
                                      className="d-inline mt-1 p-1"
                                    >
                                      Encerrada
                                    </CBadge>
                                  ) : new Date(activity.activity_start) >
                                    new Date() ? (
                                    <CBadge
                                      color="light"
                                      className="d-inline mt-1 p-1"
                                    >
                                      Em breve
                                    </CBadge>
                                  ) : (
                                    <CBadge
                                      color="danger"
                                      className="d-inline mt-1 p-1"
                                    >
                                      Ao vivo
                                    </CBadge>
                                  )
                                ) : (
                                  <div className="text-muted small mt-1">
                                    {`${this.friendlyDate(
                                      activity.activity_start
                                    )} - ${this.friendlyDate(
                                      activity.activity_end
                                    )}`}
                                  </div>
                                )}
                              </div>
                            </CCardBody>
                            {activity.items.length !== 0 && (
                              <CCardFooter className="d-flex align-items-center justify-content-start overflow-hidden">
                                <div className="d-flex" style={{ flex: 1 }}>
                                  {activity.items.map(item => (
                                    <div
                                      key={item.id}
                                      className={`activity-item-icon activity-item-icon-${item.type_color}`}
                                    >
                                      <i
                                        className={`fa fa-${item.type_icon}`}
                                      ></i>
                                    </div>
                                  ))}
                                </div>
                              </CCardFooter>
                            )}
                          </CCard>
                        </CLink>
                      </CCol>
                    ))}
                </CRow>
              ) : (
                <div className="d-flex align-items-center justify-content-center p-3 text-muted">
                  Nenhuma atividade encontrada
                </div>
              )}
            </React.Fragment>
          )}
        </CCollapse>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunityContentActivities);
